export default __webpack_public_path__ + "static/media/favicon-callswitch.e951ce5c.svg";